export default __webpack_public_path__ + "static/media/Icons_ElectricOff_Red Icon.d1e9bed4.svg";